import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { FolderType } from '../../../../AddToGroupsPanel/redux/types';
var GroupTabs = function (_a) {
    var selectSubmissionType = _a.selectSubmissionType, selectedSubmissionType = _a.selectedSubmissionType, className = _a.className;
    var t = useTranslation().t;
    var tabs = useMemo(function () { return [
        {
            index: FolderType.Gallery,
            label: t('addToGroup.folderType.gallery'),
        },
        {
            index: FolderType.Collection,
            label: t('addToGroup.folderType.collection'),
        },
    ]; }, [t]);
    return (React.createElement(FormTabs, { items: tabs, activeIndex: selectedSubmissionType, onChange: selectSubmissionType, className: className }));
};
GroupTabs.displayName = 'GroupTabs';
export default GroupTabs;
//# sourceMappingURL=GroupTabs.js.map